import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IEditButtonProps extends ICustomButtonProps {}

export const EditButton: React.FunctionComponent<IEditButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.NONE,
  text,
}) => {
  const { t } = useTl();

  return (
    <Button
      icon={IconNames.EDIT}
      title={text ? null : t(ETLCodes.Edit)}
      minimal={minimal}
      onClick={onClick}
      text={text ? text : minimal ? null : t(ETLCodes.Edit)}
      intent={intent}
      loading={loading}
      disabled={disabled}
    />
  );
};
